module.exports = __webpack_public_path__ + "img/Arrow_Line_Up.edd7752a.svg";